import { render, staticRenderFns } from "./FollowLogTypeSet.vue?vue&type=template&id=1efa37e2&"
import script from "./FollowLogTypeSet.vue?vue&type=script&lang=js&"
export * from "./FollowLogTypeSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports